<div class="form-wrapper-center-flex">
  <kendo-card [width]="'auto'">
    <kendo-card-body>
      <div>
        <form [formGroup]="resetPasswordForm" class="k-form">
          <fieldset class="k-form-fieldset">
            <legend class="k-form-legend">
              {{ "RESET_PASSWORD_FORM.TITLE" | translate }}
            </legend>

            <kendo-formfield>
              <kendo-label
                [for]="password"
                [text]="'RESET_PASSWORD_FORM.PASSWORD' | translate"
              ></kendo-label>
              <input
                formControlName="password"
                type="password"
                #password
                kendoTextBox
              />
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label
                [for]="repeatPassword"
                [text]="'RESET_PASSWORD_FORM.PASSWORD_REPEAT' | translate"
              ></kendo-label>
              <input
                type="password"
                formControlName="repeatPassword"
                #repeatPassword
                kendoTextBox
              />
            </kendo-formfield>

            <div class="recaptcha-wrapper">
              <!--<re-captcha formControlName="recaptcha"></re-captcha>-->
            </div>
          </fieldset>
        </form>
      </div>
    </kendo-card-body>
    <hr kendoCardSeparator />
    <kendo-card-actions layout="end">
      <button
        themeColor="primary"
        [disabled]="resetPasswordForm.invalid"
        kendoButton
        fillMode="flat"
      >
        {{ "RESET_PASSWORD_FORM.SUBMIT" | translate }}
      </button>
    </kendo-card-actions>
  </kendo-card>
</div>
